import { useEffect, useRef } from 'react';
import { useTonAddress } from '@tonconnect/ui-react';
import { events, identify } from '../lib/analytics';
import { getTelegramUserId } from '../lib/telegram';
import { api } from '../lib/api';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
const TON_NETWORK = import.meta.env.VITE_TON_NETWORK || 'mainnet';

export function useWalletTracking(): void {
  const address = useTonAddress();
  const prevAddress = useRef<string | null>(null);

  useEffect(() => {
    if (!address || address === prevAddress.current) return;
    prevAddress.current = address;

    events.walletConnected({ address, network: TON_NETWORK });
    identify(address, { network: TON_NETWORK });

    const urlParams = new URLSearchParams(window.location.search);
    events.channelAttribution({
      address,
      utmSource: urlParams.get('utm_source') || undefined,
      utmMedium: urlParams.get('utm_medium') || undefined,
      utmCampaign: urlParams.get('utm_campaign') || undefined,
      referrer: document.referrer || undefined,
      hasReferralCode: !!localStorage.getItem('cherry_referrer'),
    });

    const telegramUserId = getTelegramUserId();
    if (telegramUserId) {
      fetch(`${API_BASE_URL}/api/profile/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          walletAddress: address,
          telegramUserId,
          telegramChatId: telegramUserId,
        }),
      }).catch(() => {});
    }

    const referrer = localStorage.getItem('cherry_referrer');
    if (referrer && referrer !== address) {
      api.trackReferral(referrer, address).catch(() => {});
      localStorage.removeItem('cherry_referrer');
    }
  }, [address]);
}
